<template>
<v-card flat>
  <v-tabs v-model='activeTab' >
    <v-tab >Zoom</v-tab>
    <v-tab >Manually configure</v-tab>

    <v-tabs-items v-model='activeTab' >
      <v-tab-item >
        <v-card flat>
          <v-card-title class='subtitle-1 overline' >
            Make this appointment online
            <v-spacer></v-spacer>
            <v-chip small dark color='success' v-if='integrationIsConnected' >
              <v-icon>check</v-icon>
              Zoom Connected
            </v-chip>
          </v-card-title>
          <v-alert type='success' :value='appointment.is_online' v-if='appointment.is_online' >
            This appointment is online
          </v-alert>
          <template v-if='integrationIsConnected' >
            <online-meeting-card
              v-if='zoommeeting'
              :appointment='zoommeeting' >
            </online-meeting-card>
            <v-list v-else class='elevation-0' >
              <appointment-list-item
                v-if='appointment'
                :with-action='false'
                :appointment='appointment' :with-color-coding='false' >
                <v-list-tile-action v-if='!appointment.is_online' slot='action' >
                  <v-btn
                    @click='makeOnline'
                    :loading='loading' color='primary' small >
                    Make online
                  </v-btn>
                </v-list-tile-action>
              </appointment-list-item>
            </v-list>
          </template>
          <v-card v-else flat >
            <v-card-title class='subtitle-1 subheading' >
              Connect to your Zoom account
              <v-spacer></v-spacer>
              <v-btn href='https://appointmentguru.co/help/zoom-integration/' flat text target="_blank">Learn more <v-icon>open_in_new</v-icon></v-btn>
              <v-btn v-if='isEnabled' :href="oauthUrl" target="_blank" color='primary' >
                Install <v-icon small class='ml-2'>open_in_new</v-icon>
              </v-btn>
              <v-btn v-else outline disabled :href="oauthUrl" color='primary' >
                Coming soon
              </v-btn>
            </v-card-title>
            <v-card-text>
              <ul>
                <li>
                  <strong>To create online appointments, you will need to configure an integration with
                  <a href="https://zoom.us" target="_blank" >Zoom</a></strong>
                  <ul>
                    <li>Zoom is a tool for doing online meetings</li>
                    <li>Zoom is free to use for 1-on-1 meetings</li>
                    <li>Zoom is free to use for group meetings shorter than 40 minutes</li>
                    <li>There are paid plans should you need more</li>
                  </ul>
                </li>
                <li><strong>With the AppointmentGuru integration, you can:</strong>
                  <ul>
                    <li>Make an appointment into an "online appointment"</li>
                    <li>AppointmentGuru will automatically create the meeting in Zoom and make all the relevent information available to you and easy to share</li>
                    <li>Automatically add meeting information to your notifications</li>
                    <li>Easily share Zoom meeting information with your clients</li>
                    <li>Start the meeting directly from AppointmentGuru</li>
                  </ul>
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-card>
      </v-tab-item>
      <v-tab-item >
        <online-meeting-card
          :editmode='true'
          v-if='appointment'
          :appointment='appointment' >
        </online-meeting-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
  <!-- <online-meeting-card
    v-if='zoommeeting'
    :appointment='zoommeeting' >
  </online-meeting-card> -->
  <!-- <v-card>
    <v-card-title class='subtitle-1 overline' >
    </v-card-title>
    <v-card-text>
      On success:
      * Send appointment information to client
      * Open in Zoom
    </v-card-text>
  </v-card> -->
</v-card>
</template>
<script>
import OnlineMeetingCard from '@/components/cards/OnlineMeetingCard'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import ZoomMixins from './mixins'

export default {
  mixins: [ZoomMixins],
  components: {AppointmentListItem, OnlineMeetingCard},
  name: 'MakeAppointmentOnline',
  props: {
    appointment: { type: Object, required: true }
  },
  data () {
    return {
      loading: false,
      zoommeeting: null,
      isEnabled: true,
      activeTab: 0
    }
  },
  watch: {
    appointment: {
      immediate: true,
      handler () {
        if (this.appointment) {
          this.zoommeeting = null
        }
      }
    }
  },
  methods: {
    makeOnline () {
      let appointments = this.appointment.id.toString()
      let data = {
        appointments,
        practitioner_id: this.me.id
      }
      this.loading = true
      this.performAction(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        false,
        'bulk_make_online',
        data
      ).then((result) => {
        this.loading = false
        if (result && result.data && result.data.results && result.data.results.length === 1) {
          this.zoommeeting = result.data.results[0]
          this.appointment.zoom_join_url = this.zoommeeting.zoom_join_url
          this.appointment.zoom_meeting_password = this.zoommeeting.zoom_meeting_password
          this.appointment.is_online = true
        }
      }).catch((result) => {
        this.loading = false
      })
    }
  },
  computed: {
    onlineRequest () {
    },
    integrationIsConnected () {
      return this.integration && this.integration.is_connected
    }
  }
}
</script>



// WEBPACK FOOTER //
// MakeAppointmentOnline.vue?65bb4742